class AnnouncementModal extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector("[data-announcement-modal-trigger]");
    this.dialog = this.querySelector("[data-announcement-modal-dialog]");
    this.closeButton = this.querySelector("[data-announcement-modal-close]");

    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.trigger.addEventListener("click", this.open);
    this.closeButton.addEventListener("click", this.close);
    this.dialog.addEventListener("click", this.handleBackdropClick);
    this.dialog.addEventListener("close", this.handleClose);
    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("scroll", this.updatePosition, { passive: true });
  }

  disconnectedCallback() {
    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.trigger.removeEventListener("click", this.open);
    this.closeButton.removeEventListener("click", this.close);
    this.dialog.removeEventListener("click", this.handleBackdropClick);
    this.dialog.removeEventListener("close", this.handleClose);
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("scroll", this.updatePosition);
    document.documentElement.classList.remove("announcement-modal-open");
  }

  open = () => {
    if (this.dialog.open) return;

    this.updatePosition();
    this.dialog.showModal();
    document.documentElement.classList.add("announcement-modal-open");
    this.trigger.setAttribute("aria-expanded", "true");
    this.closeButton.focus();
  };

  close = () => {
    if (this.dialog.open) this.dialog.close();
  };

  handleBackdropClick = (event) => {
    if (event.target !== this.dialog) return;

    const bounds = this.dialog.getBoundingClientRect();
    const inside =
      event.clientX >= bounds.left &&
      event.clientX <= bounds.right &&
      event.clientY >= bounds.top &&
      event.clientY <= bounds.bottom;

    if (!inside) this.close();
  };

  handleClose = () => {
    document.documentElement.classList.remove("announcement-modal-open");
    this.trigger.setAttribute("aria-expanded", "false");
    this.trigger.focus();
  };

  updatePosition = () => {
    const row = this.closest("[data-header-announcement]");
    if (!row) return;

    const top = Math.max(12, row.getBoundingClientRect().bottom + 12);
    this.dialog.style.setProperty("--announcement-modal-top", `${top}px`);
  };
}

if (!customElements.get("announcement-modal")) {
  customElements.define("announcement-modal", AnnouncementModal);
}

const updateHeaderStack = () => {
  const root = document.documentElement;
  const announcement = document.querySelector("[data-header-announcement]");
  const quickNavigation = document.querySelector("[data-quick-navigation]");
  const siteHeader = document.querySelector(".solstice__header");

  root.style.setProperty("--announcement-row-height", `${announcement?.offsetHeight || 0}px`);
  root.style.setProperty("--quick-navigation-row-height", `${quickNavigation?.offsetHeight || 0}px`);
  root.style.setProperty("--site-header-height", `${siteHeader?.offsetHeight || 0}px`);
};

const headerStackObserver = new ResizeObserver(updateHeaderStack);

const observeHeaderStack = () => {
  document
    .querySelectorAll("[data-header-announcement], [data-quick-navigation], .solstice__header")
    .forEach((element) => headerStackObserver.observe(element));
  updateHeaderStack();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observeHeaderStack, { once: true });
} else {
  observeHeaderStack();
}

document.addEventListener("shopify:section:load", observeHeaderStack);
